<ng-container *transloco="let t">
  <div [formGroup]="form">
    <div formGroupName="fivTestResult" class="group-block">
      <h3 class="group-title">{{ t('fivTestTitle') }}</h3>
      <div class="group-inputs">
        <mat-form-field appearance="outline" class="w-full">
          <mat-label>{{ t('fivTestTitle') }}</mat-label>
          <textarea
            matInput
            [formControlName]="currentLang"
            rows="3"
          ></textarea>
        </mat-form-field>
      </div>
    </div>
    <div formGroupName="felvTestResult" class="group-block">
      <h3 class="group-title">{{ t('felvTestTitle') }}</h3>
      <div class="group-inputs">
        <mat-form-field appearance="outline" class="w-full">
          <mat-label>{{ t('felvTestTitle') }}</mat-label>
          <textarea
            matInput
            [formControlName]="currentLang"
            rows="3"
          ></textarea>
        </mat-form-field>
      </div>
    </div>
  </div>
</ng-container>
